export interface VideoStreamState {
  videoPlayer?: HTMLVideoElement;
  videoStream?: MediaStream;
  mediaTrack?: MediaStreamTrack;
  isTorchOn?: boolean;
  currentCamera?: MediaDeviceInfo;
  currentPhotoUrl?: string;
  isLoading?: boolean;
  isPreview?: boolean;
  isBackCamera: boolean;
  isCapturing?: boolean;
  capabilities?: {
    mainCamera?: MediaDeviceInfo;
    frontCamera?: MediaDeviceInfo;
    isTorchSupported?: boolean;
    imageWidth: { max: number; min: number };
    imageHeight: { max: number; min: number };
  };
  focusQuality?: number;
  focusQualityThreshold?: number;
}

export enum VideoStreamActionTypes {
  SET_INITIAL_DATA,
  SET_CURRENT_CAMERA_ID,
  SET_TORCH_STATUS,
  SET_CURRENT_PHOTO_URL,
  SET_IS_LOADING,
  SET_IS_PREVIEW,
  SET_IS_BACK_CAMERA,
  START_CAPTURING,
  STOP_CAPTURING,
  SET_QUALITY_THRESHOLD,
}

export function setInitialData(initialData: VideoStreamState) {
  return {
    type: VideoStreamActionTypes.SET_INITIAL_DATA,
    payload: initialData,
  };
}

export function setCurrentCamera(camera: MediaDeviceInfo) {
  return {
    type: VideoStreamActionTypes.SET_CURRENT_CAMERA_ID,
    payload: camera,
  };
}

export function setTorchStatus(isTorchOn: boolean) {
  return {
    type: VideoStreamActionTypes.SET_TORCH_STATUS,
    payload: isTorchOn,
  };
}

export function setCurrentPhotoBlob(url?: string, focusQuality?: number) {
  return {
    type: VideoStreamActionTypes.SET_CURRENT_PHOTO_URL,
    payload: { url, focusQuality },
  };
}

export function setIsLoadingAction(isLoading: boolean) {
  return {
    type: VideoStreamActionTypes.SET_IS_LOADING,
    payload: isLoading,
  };
}

export function setIsPreviewAction(isPreview: boolean) {
  return {
    type: VideoStreamActionTypes.SET_IS_PREVIEW,
    payload: isPreview,
  };
}

export function setIsBackCamera(isBackCamera: boolean) {
  return {
    type: VideoStreamActionTypes.SET_IS_BACK_CAMERA,
    payload: isBackCamera,
  };
}

export function startCapturing() {
  return {
    type: VideoStreamActionTypes.START_CAPTURING,
    payload: undefined,
  };
}

export function stopCapturing() {
  return {
    type: VideoStreamActionTypes.STOP_CAPTURING,
    payload: undefined,
  };
}

export function setQualityThreshold(quality: number) {
  return {
    type: VideoStreamActionTypes.SET_QUALITY_THRESHOLD,
    payload: quality,
  };
}

export function reducer(
  state: VideoStreamState,
  action: { type: VideoStreamActionTypes; payload: any }
): VideoStreamState {
  switch (action.type) {
    case VideoStreamActionTypes.SET_INITIAL_DATA:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case VideoStreamActionTypes.SET_CURRENT_CAMERA_ID:
      return {
        ...state,
        currentCamera: action.payload,
      };
    case VideoStreamActionTypes.SET_TORCH_STATUS:
      return {
        ...state,
        isTorchOn: action.payload,
      };
    case VideoStreamActionTypes.SET_CURRENT_PHOTO_URL:
      return {
        ...state,
        currentPhotoUrl: action.payload.url,
        isLoading: false,
        isPreview: !!action.payload.url,
        focusQuality: action.payload.focusQuality,
        isCapturing: false,
      };
    case VideoStreamActionTypes.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case VideoStreamActionTypes.SET_IS_PREVIEW:
      return {
        ...state,
        isPreview: action.payload,
      };
    case VideoStreamActionTypes.SET_IS_BACK_CAMERA:
      return {
        ...state,
        isBackCamera: action.payload,
      };
    case VideoStreamActionTypes.START_CAPTURING:
      return {
        ...state,
        isCapturing: true,
      };
    case VideoStreamActionTypes.STOP_CAPTURING:
      return {
        ...state,
        isCapturing: false,
      };
    case VideoStreamActionTypes.SET_QUALITY_THRESHOLD:
      return {
        ...state,
        focusQualityThreshold: action.payload,
      };
    default:
      return state;
  }
}
